var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.656 32 0 60.656 0 96V416C0 451.348 28.656 480 64 480H384C419.344 480 448 451.348 448 416V96C448 60.656 419.344 32 384 32ZM358.625 326.625C346.125 339.125 325.875 339.125 313.375 326.625L224 237.25L134.625 326.625C122.125 339.125 101.875 339.125 89.375 326.625S76.875 293.875 89.375 281.375L201.375 169.375C207.625 163.125 215.812 160 224 160S240.375 163.125 246.625 169.375L358.625 281.375C371.125 293.875 371.125 314.125 358.625 326.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareChevronUp);
export default __webpack_public_path__ + "static/media/square-chevron-up.6f03d8fe793641f1d149adc06a60a9ae.svg";
export { ForwardRef as ReactComponent };